import { createContext, useContext } from 'react';
import { Role } from '@/shared/permissions/roles';

export interface DashboardFilters {
  dateRange?: [Date, Date];
  department?: string;
  employeeId?: string;
  projectId?: string;
  salesTeamId?: string;
}

export interface DashboardContextValue {
  role: Role | null;
  filters: DashboardFilters;
  setFilters: (filters: Partial<DashboardFilters>) => void;
  isRefreshing: boolean;
  refreshAll: () => void;
  registerWidgetRefresh: (id: string, refreshFn: () => void) => void;
  unregisterWidgetRefresh: (id: string) => void;
}

export const DashboardContext = createContext<DashboardContextValue | null>(null);

export function useDashboardContext() {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboardContext must be used within <DashboardProvider>');
  return ctx;
}
